import axiosInstance from "@API/axios";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";
import { object } from "joi";

const useGetAll = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const getAll = (URL, err, params = {}) => {
    setLoading(true);
    return axiosInstance
      .get(URL, { params }) // Pass params to axios config
      .then((response) => {
        setLoading(false);
        return response.data;
      })
      .catch((error) => {
        dispatch(
          setSnackbar({
            open: true,
            message:
              err ||
              (typeof error.response?.data === "object" &&
                error.response?.data?.details) ||
              (typeof error.response?.data === "string" &&
                error.response?.data) ||
              "Internal Server Error",
            error: true,
          })
        );
        setLoading(false);
      });
  };

  return { loading, getAll };
};

export default useGetAll;
